/**
 * Parse the time to string
 * @param {(number)} time
 * @returns {string}
 */
export function formatDate(value) {
    if (!value) {
        return '';
    }
    let date = new Date(value)
    let y = date.getFullYear()
    let MM = date.getMonth() + 1
    MM = MM < 10 ? ('0' + MM) : MM
    let d = date.getDate()
    d = d < 10 ? ('0' + d) : d
    let h = date.getHours()
    h = h < 10 ? ('0' + h) : h
    let m = date.getMinutes()
    m = m < 10 ? ('0' + m) : m
    let s = date.getSeconds()
    s = s < 10 ? ('0' + s) : s
    return y + '-' + MM + '-' + d + ' ' + h + ':' + m + ':' + s
        // return y + '-' + MM + '-' + d
}

/**
 * deepClone=>
 * @param {(object)}
 * @returns {object}
 */

export function deepClone(obj) {
    var target = {};
    for (var key in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, key)) {
            if (typeof obj[key] === 'object') {
                target[key] = deepClone(obj[key]);
            } else {
                target[key] = obj[key];
            }
        }
    }
    return target;
}


/**
 * mobileFilter=>手机号中间隐藏
 * @param {(Number)}
 * @returns {String}
 */
export function mobileFilter(val) {
    if (val) {
        let reg = /^(.{3}).*(.{4})$/
        return val.replace(reg, '$1****$2') || '-'
    }

}

/**
 * codeFilter=>
 * @param {(Number)}
 * @returns {String}
 */
export function codeFilter(val) {
    console.log(val);
    if (val.length > 5) {
        let star = ''
        for (var i = 0; i < val.length - 2; i++) {
            star = star + '*'
        }
        return val.substring(0, 1) + star + val.substring(val.length - 1, val.length);
    }

}


/**
 * ArrayFiflter=>数组过滤
 * @param {(Array,Number)}
 * @returns {Array}
 */
export function group(array, subGroupLength) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
        newArray.push(array.slice(index, (index += subGroupLength)));
    }
    return newArray;
}

/**
 * nameFilter=>
 * @param {(Number||String)}
 * @returns {String}
 */
export function processName(str) {
    if (null != str && str != undefined) {
        let star = ''
        if (str.length <= 2) {
            return "*" + str.substring(1, 2);
        } else if (str.length === 3) {
            return "*" + str.substring(1, 3);
        } else {
            for (var i = 0; i < str.length - 2; i++) {
                star = '*' + star
            }
            return str.substring(0, 2) + star + str.substring(str.length - 2, str.length);
        }
    }
}

/**
 * UrlSearch=>
 * @param {(window.url)}
 * @returns {String||Number}
 */
export function GetUrlParam(paraName) {
    var url = document.location.toString();
    var arrObj = url.split("?");

    if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;

        for (var i = 0; i < arrPara.length; i++) {
            arr = arrPara[i].split("=");

            if (arr != null && arr[0] == paraName) {
                return arr[1];
            }
        }
        return "";
    } else {
        return "";
    }
}

//删除给定对象中值为空的键值对
export function filterParams(obj) {
    var _newPar = {};
    for (var key in obj) {
        if ((obj[key] === 0 || obj[key] === false || obj[key]) && obj[key].toString().replace(/(^\s*)|(\s*$)/g, '') !== '' && (obj[key] !== null || obj[key] !== NaN || obj[key] !== undefined)) {
            _newPar[key] = obj[key];
        }
    }
    return _newPar;
}

//类型数字转文字
export function sourceType(typeNum) {
    switch (typeNum) {
        case 975260:
            return "用户中心";
            break;
        case 955210:
            return "时间戳";
            break;
        case 925220:
            return "壹签";
            break;
        case 955740:
            return "电子证据";
            break;
        case 955255:
            return "RA";
            break;
        case 995280:
            return "经销商前台";
            break;
        case 915290:
            return "经销商后台";
            break;
        case 952310:
            return "知识产权";
            break;
        case 700025:
            return "邮件认证";
            break;
        case 954210:
            return "权利卫士";
            break;
        case 975281:
            return "维权平台";
            break;
        case 800001:
            return "天平阳光";
            break;
        case 801001:
            return "百度";
            break;
    }
}

//将给定数组，拆分成若干个数组的集合
export function splitArray(array, num) {
    let index = 0;
    let newArray = [];
    while (index < array.length) {
        newArray.push(array.slice(index, index += num));
    }
    return newArray;
}

//整理数组对象，账户概览页饼图专用
export function regroupData(array) {
    let newArray = [];
    let obj;
    for (let i = 0; i < array.length; i++) {
        obj = array[i];
        obj.name = sourceType(array[i].sourceType);
        obj.value = array[i].tsCount;
        newArray.push(obj);
    }
    return newArray
}

//计算数组对象中某个字段的总和，账户概览页饼图专用
export function numTotal(array) {
    let total = 0;
    for (let i = 0; i < array.length; i++) {
        total += array[i].tsCount;
    }
    return total
}

//根据时间戳计算时间差
export function diffTime(startDate, endDate) {
    var diff = endDate - startDate; //时间差的毫秒数 
    //计算出相差天数 
    var days = Math.floor(diff / (24 * 3600 * 1000));

    //计算出小时数 
    var leave1 = diff % (24 * 3600 * 1000); //计算天数后剩余的毫秒数 
    var hours = Math.floor(leave1 / (3600 * 1000));
    //计算相差分钟数 
    var leave2 = leave1 % (3600 * 1000); //计算小时数后剩余的毫秒数 
    var minutes = Math.floor(leave2 / (60 * 1000));

    //计算相差秒数 
    var leave3 = leave2 % (60 * 1000); //计算分钟数后剩余的毫秒数 
    var seconds = Math.round(leave3 / 1000);

    var returnStr = seconds + "秒";
    if (minutes > 0) {
        returnStr = minutes + "分" + returnStr;
    }
    if (hours > 0) {
        returnStr = hours + "小时" + returnStr;
    }
    if (days > 0) {
        returnStr = days + "天" + returnStr;
    }
    //console.log((days * 24 + hours) + '：' + minutes + '：' + seconds)
    let time = {
        hours: days * 24 + hours,
        minutes,
        seconds
    }
    return time;
}

//根据给定字段，在给定对象数组中去重，保留最先找到的。
export function uniqueArr(arr, val) {
    let res = new Map();
    return arr.filter(item => !res.has(item[val]) && res.set(item[val], 1))
}

export function isWeixin() {
    let ua = navigator.userAgent.toLowerCase();
    if (ua.match(/MicroMessenger/i) == "micromessenger") {
        return true;
    } else {
        return false;
    }
}

export function hrefOpen(url) {
    var link = document.createElement('a')
    link.target = '_blank'
    link.href = url
    link.id = 'href'
    document.body.appendChild(link)
    link.click()
  }


export function fileSize(value) {
    let size=value
    let num = 1024.00; //byte
    if (!size)
        return 0;
    if (size < num)
        return size + "B";
    if (size < Math.pow(num, 2))
        return (size / num).toFixed(2) + "K"; //kb
    if (size < Math.pow(num, 3))
        return (size / Math.pow(num, 2)).toFixed(2) + "M"; //M
    if (size < Math.pow(num, 4))
        return (size / Math.pow(num, 3)).toFixed(2) + "G"; //G
    return (size / Math.pow(num, 4)).toFixed(2) + "T"; //T
}